/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import App from 'apmui/App';
import EventTags from 'apmui/EventTags';
import { CommonDialogAction } from './Model';
import * as Dialog from './DialogHelper';

const app = App.get();
app.subscribeDefault(EventTags.CONFIGURE, (_, page) => {
    if (!page.dialogs) {
        page.dialogs = [];
    }
});

app.subscribeDefault(EventTags.DIALOG_OPEN, ({ detail }, page) => {
    /* Check if the dialog class handler provided the configuration */
    if (typeof detail.dialog !== 'string') {
        const dialog = detail.dialog;
        // save callback if specified
        detail.dialog.callback = detail.callback;
        // remove stale copies of the same dialog
        page.dialogs = page.dialogs.filter((x) => !Dialog.equal(x, dialog));
        // insert the dialog into the priority queue
        if (typeof detail.dialog.priority === 'number') {
            let i;
            for (i = 0; i < page.dialogs.length; i++) {
                if (
                    typeof page.dialogs[i].priority !== 'number' ||
                    page.dialogs[i].priority! <= detail.dialog.priority
                ) {
                    break;
                }
            }
            page.dialogs.splice(i, 0, detail.dialog);
        } else {
            page.dialogs.push(detail.dialog);
        }
    }
});

app.subscribeDefault(EventTags.DIALOG_CLOSE, ({ detail }, page) => {
    let i = 0;
    while (i < page.dialogs.length) {
        const dialog = page.dialogs[i];
        if (
            (typeof detail.dialog === 'string' && dialog.class === detail.dialog) ||
            (typeof detail.dialog !== 'string' && Dialog.equal(dialog, detail.dialog))
        ) {
            /* Fallback rejection for dialogs */
            if (dialog.callback) {
                if (detail.resolve) {
                    dialog.callback.resolve(detail.resolve);
                } else {
                    dialog.callback.reject(EventTags.DIALOG_CLOSE);
                }
            }
            page.dialogs.splice(i, 1);
            continue;
        }
        ++i;
    }
});

app.subscribeDefault(EventTags.DIALOG_ACTION, ({ detail }, page) => {
    const dialog = Dialog.get(page, detail.dialog);

    switch (detail.action) {
        case CommonDialogAction.CANCEL:
            app.closeModal({
                dialog: detail.dialog,
            });
            break;
        case CommonDialogAction.EXPAND:
            if (dialog && dialog.entries) {
                for (const action of dialog.entries) {
                    if (!('type' in action) && !('text' in action)) {
                        if (action.id === CommonDialogAction.EXPAND) {
                            action.hidden = true;
                        } else if (action.hidden) {
                            action.hidden = false;
                        }
                    }
                }
            }
            break;
        case CommonDialogAction.UPDATE:
            if (dialog && dialog.entries) {
                for (const entry of dialog.entries) {
                    if ('type' in entry && entry.name === detail.field) {
                        entry.value = detail.value;
                    }
                }
            }
            break;
        default:
            app.closeModal({
                dialog: detail.dialog,
                resolve: detail.action,
            });
            break;
    }
});
